import styled, { css } from 'styled-components';

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const { 
      color,
      inputsBorderRadius,
      calendarBorderRadius,
      calendarCellsBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};

    const {
      widgetContainerBorderRadius,
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }
       
      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }

        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }
      .react-datepicker {
        .react-datepicker__day-names {
          border-radius: ${calendarBorderRadius}px;
        }
        .react-datepicker__day {
          border-radius: ${calendarCellsBorderRadius}px;
        }
      }
      .filter-container {
        border-radius: ${widgetContainerBorderRadius}px;
      }
    `;
  }
}`;
